module.exports = __webpack_public_path__ + "img/fal-video.744f6dbb.svg";